import React, { useCallback, useEffect, useState } from 'react';
import { TabPanel, Tabs } from '@tencent/spaui';
import _ from 'lodash';
import globalStore from '@/stores/index';
import TipIcon from '@/common-components/tip-icon';
import './assets/less/index.scoped.less';

export interface SubNavProps {
  /**
   * 页面地址
   */
  href?: string;
  /**
   * head后置内容
   */
  endOfHeadContent?: React.ReactNode;
  [key: string]: any;
}

export const SubNav: React.FC<SubNavProps> = (props) => {
  const { href = '', endOfHeadContent, ...otherProps } = props;
  const account: any = globalStore.account || {};
  const history: any = globalStore.history || {};
  const pathname = href || history?.location?.pathname;

  const [value, setValue] = useState(pathname);

  const { siteMap = {} } = account || {};
  const currentSubNav: any[] = siteMap.pathSubNavMap?.[pathname] || [];

  useEffect(() => {
    if (currentSubNav) {
      currentSubNav.forEach((item, index) => {
        if (item.match && item.match(pathname)) {
          setValue(item.href);
        }
      });
    }
  }, [pathname]);

  const onChange = useCallback((e, value) => {
    setValue(value);
    history?.push(value);
  }, []);

  if (!currentSubNav.length) {
    return null;
  }

  return (
    <Tabs className="sub-nav" {...otherProps} endOfHeadContent={<div className="sub-nav-right">{endOfHeadContent}</div>} value={value} unmountInactivePanel={true} needSlider={false} onChange={onChange}>
      {currentSubNav.map((item, index) => {
        const href = item.href;
        return <TabPanel
          key={href}
          tab={<TipIcon value={item.label}>{item.tip}</TipIcon>}
          name={href}
          data-report-global={`third-nav.${item.key || item.id || item.href}`}></TabPanel>;
      })}
    </Tabs>
  );
};

export default SubNav;
